export default __webpack_public_path__ + "static/media/success.ccdc9f9a.png";